/* ===== Подключение картинок ===== */
import imgLogo from "../assets/images/logo.png";


const footerData = {
  brand: {
    title: "ООО \"ДИЗЕЛЬ ГАРАНТ\"",
    description: "127055, РОССИЯ, г МОСКВА, \nпер ТИХВИНСКИЙ,ДОМ 6, офис КВ. 3",
    logoSrc: imgLogo, // если нужно
  },

  nav: {
    title: "Навигация",
    links: [
      { label: "О компании", href: "#about" },
      { label: "Услуги", href: "#services" },
      { label: "Кейсы", href: "#cases" },
      { label: "Контакты", href: "#contacts" },
    ],
  },

  contacts: {
    title: "Контакты",
    items: [
      { label: "+7 (977) 090-60-36", href: "tel:+79770906036" },
      { label: "diz.garant@yandex.ru", href: "mailto:diz.garant@yandex.ru" },
      { label: "Москва и область", href: null },
    ],
    // socials: [
    //   { label: "Telegram", href: "https://t.me/yourlink" },
    //   { label: "WhatsApp", href: "https://wa.me/79990000000" },
    // ],
  },

  legal: {
    links: [
      { label: "Политика конфиденциальности", href: "/privacy" },
      // { label: "Пользовательское соглашение", href: "/terms" },
    ],
  },

  bottom: {
    copyright: "© 2026. Все права защищены.",
    madeBy: "", // можно оставить пустым или типа "Сделано в S2S"
  },
};

export default footerData;
